import React from 'react'
import FooterStyle from './styles'

const Footer = () => {
  return (
    <FooterStyle>
      Copyright 2022 <strong>© K STADIUM</strong> All rights reserved.
    </FooterStyle>
  )
}

export default Footer
